<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange', 'urgentContextMenu']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

// MakerHub: right-click on the Urgent tab opens the bulk-clear menu in ChatList
const onTabContextMenu = (event, item) => {
  if (item.key !== 'urgent') return;
  event.preventDefault();
  emit('urgentContextMenu', { x: event.pageX, y: event.pageY });
};

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <woot-tabs
    :index="activeTabIndex"
    class="w-full px-2 -mt-1 py-0 h-10 [&_ul]:p-0 [&_li]:mx-1 [&_a]:text-xs [&_a_div]:text-[0.625rem] [&_a_div]:h-[17px] [&_a_div]:min-w-[17px] [&_a_div]:px-1"
    @change="onTabChange"
  >
    <woot-tabs-item
      v-for="(item, index) in items"
      :key="item.key"
      class="text-xs [&_a]:font-medium"
      :index="index"
      :name="item.name"
      :count="item.badgeCount"
      :count-class="
        ['all', 'urgent', 'pending'].includes(item.key) && item.badgeCount
          ? 'bg-n-ruby-9 text-white'
          : ''
      "
      is-compact
      @contextmenu="onTabContextMenu($event, item)"
    />
  </woot-tabs>
</template>
